<template>
    <div class="con">
        <div v-if="status">
            <div class="log log_r" v-if="status == 1"><Icon type="md-checkmark" size='26'/></div>
            <div class="log log_e" v-else><Icon type="md-close" size='26'/></div>
        </div>
        <div class="tit-head">
            <div :class="[{'rightT':status == 1},{'errorT':status == -1}]">单选题</div>
            <!-- <div class="stem" v-html="info.title"></div> -->
            <mavonEditor 
                :class="[{'right':status == 1},{'error':status == -1}]"
                :boxShadow="false" 
                styleEditor="min-height: 20px;width: auto;" 
                :content="info.title" 
                :subfield="false" 
                :toolbarsFlag="false" 
                previewBackground="#fff"
                defaultOpen="preview" 
            />
        </div>
        
        <div class="single">
            <Radio-group v-model="yourAnswer" vertical>
                <Radio label="A" disabled>
                    <div>A、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsA" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                    <!-- <span v-html="info.optionsA"></span> -->
                </Radio>
                <Radio label="B" disabled>
                    <div>B、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsB" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </Radio>
                <Radio label="C" disabled>
                    <div>C、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsC" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </Radio>
                <Radio label="D" disabled v-if="info.optionsD">
                    <div>D、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsD" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />    
                </Radio>
                <Radio label="E" disabled v-if="info.optionsE">
                    <div>E、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsE" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />    
                </Radio>
                <Radio label="F" disabled v-if="info.optionsF">
                    <div>F、</div>
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="info.optionsF" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />    
                </Radio>
            </Radio-group>
        </div>
        <div class="right-key"><span>正确答案：{{correctAnswer}} </span> <span @click="showResolute"  v-if="txtSolution || videoSolution">显示解析</span></div>
        <div class="resolve" v-if="showResolutionBox && (txtSolution||videoSolution)" >
            <div class="text" v-if="txtSolution">
                <div style='color:#FF9D00'>文字解析：</div>
                <div >
                    <mavonEditor 
                        :boxShadow="false" 
                        styleEditor="min-height: 20px;width: auto;" 
                        :content="txtSolution" 
                        :subfield="false" 
                        :toolbarsFlag="false" 
                        previewBackground="#fff"
                        defaultOpen="preview" 
                    />
                </div>
            </div>
            <div class="video" v-if="videoSolution">
                <div>视频解析：</div>
                <video :src="videoSolution" controls></video>
            </div>
        </div>
    </div>
</template>
<script>
import mavonEditor from './mavonEditor.vue'
export default {
    components:{ mavonEditor },
    props:{
        info:{
            type:Object,
            default:null
        },
        correctAnswer:{
            type:String,
            default:null
        },
        yourAnswer:{
            type:String,
            default:null
        },
        txtSolution:{
            type:String,
            default:null
        },
        videoSolution:{
            type:String,
            default:null
        },
        status:{
            type:Number,
            default:null
        }
    },
    data(){
        return{
            showResolutionBox: false,
        }
    },
    mounted(){
        // console.log(this.txtSolution,this.videoSolution,'this.yourAnswer')
        
    },
    methods:{
        showResolute(){
            this.showResolutionBox = !this.showResolutionBox
        },
        
    }
}
</script>
<style lang="less" scoped>
@import './style/common.less';
.single {
    margin-left: 50px;
    /deep/ .ivu-radio-wrapper {
        display: flex;
        margin: 10px 0 10px 10px;
        height: auto;
        span:nth-child(2) {
            display: inline-flex;
        }
        .ivu-radio {
            margin-top: 8px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/practise/components/questionSingleView.vue